function copyURLToClipboard(url: string) {
  navigator.clipboard.writeText(url)
}

export default copyURLToClipboard
